import * as THREE from 'three';
import type { PixelPosition } from '../../tilemap/types';

export type ProjectionMode = 'perspective' | 'orthographic';
export type OrbitDirection = 'left' | 'right';

export interface ProjectionController {
  readonly camera: THREE.Camera;
  syncViewport(width: number, height: number): void;
  updateCamera(target: THREE.Vector3): boolean;
  snapToTarget(target: THREE.Vector3): void;
  rotateOrbit(direction: OrbitDirection): void;
  adjustZoom(deltaY: number): boolean;
  adjustTilt(deltaY: number): boolean;
  setRayFromScreen(
    screenX: number,
    screenY: number,
    canvasWidth: number,
    canvasHeight: number,
    raycaster: THREE.Raycaster,
    ndcPointer: THREE.Vector2,
  ): void;
  projectWorldPoint(
    worldX: number,
    worldY: number,
    worldZ: number,
    canvasWidth: number,
    canvasHeight: number,
    scratch: THREE.Vector3,
  ): PixelPosition;
}

export const CAMERA_OFFSET = new THREE.Vector3(-4.8, 8.2, 6.8);
export const CAMERA_LOOK_SMOOTHING = 0.16;
export const DEFAULT_CAMERA_DISTANCE = CAMERA_OFFSET.length();
export const DEFAULT_CAMERA_AZIMUTH = THREE.MathUtils.euclideanModulo(
  Math.atan2(CAMERA_OFFSET.z, CAMERA_OFFSET.x) - THREE.MathUtils.degToRad(35),
  Math.PI * 2,
);
export const DEFAULT_CAMERA_TILT = Math.asin(CAMERA_OFFSET.y / DEFAULT_CAMERA_DISTANCE);
export const MIN_CAMERA_TILT = THREE.MathUtils.degToRad(25);
export const MAX_CAMERA_TILT = THREE.MathUtils.degToRad(78);
export const CAMERA_TILT_STEP = 0.0015;
export const MIN_CAMERA_DISTANCE = DEFAULT_CAMERA_DISTANCE * 0.55;
export const MAX_CAMERA_DISTANCE = DEFAULT_CAMERA_DISTANCE * 1.9;
export const CAMERA_ZOOM_STEP = 0.01;
export const CAMERA_ORBIT_STEP = THREE.MathUtils.degToRad(5);
export const CAMERA_SETTLE_EPSILON = 0.001;
export const PERSPECTIVE_FOV_DEGREES = 52;
